module.exports = __webpack_public_path__ + "img/iconImg4.ea0ba164.png";